<template>
	<div class="products-list">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h3>Check Promotions</h3>

		<div class="productExport">
			<input type="file" @change="loadTextFromFile" />
		</div>

		{{ progress }} of {{ product_total }}

		<div>
			<ul>
				<li v-for="(error, index) in errors" :key="index" class="update-error">
					{{ error }}
				</li>
			</ul>
		</div>
		<!-- <div v-if="progress > 0" class="progress-bar">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div> -->
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'productsList',
	data: function() {
		return {
			isLoading: false,
			progress: 0,
			product_total: 0,
			errors: []
		}
	},

	mounted: async function() {},

	computed: {},

	methods: {
		async loadTextFromFile(ev) {
			this.isLoading = true
			const file = ev.target.files[0]
			const reader = new FileReader()

			reader.onload = async event => {
				var raw = event.target.result.split(/\r?\n/)

				var header = raw[0].split(/,/)

				let promo_code_index = header.indexOf('PROMOTION CODE')

				if (promo_code_index == -1) {
					this.$swal.fire('Missing header "PROMOTION CODE"!')

					this.isLoading = false

					return
				}

				// Remove first row
				raw.shift()

				this.product_total = raw.length - 1

				// Loop every row to put it in array
				for (let products of raw) {
					// var splitData = data.split(/,/)
					var splitData = products.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g)

					if (splitData[promo_code_index]) {
						this.progress++

						const promo_code = splitData[promo_code_index].replace(/['"]+/g, '')

						let data = {
							name: promo_code,
							limit: 1
						}

						let apiGetPromo = await this.$api.getPromo({ data })

						if (!apiGetPromo || apiGetPromo.data.total < 1) {
							this.errors.push(promo_code + ' is missing.')
						}
					}
				}

				this.isLoading = false
			}

			reader.readAsText(file)
			this.isLoading = false
		}
	}
}
</script>

<style scoped>
@import '../styles/ProductsList.css';
</style>
